import { createContext } from 'react';

/**
 * Context for whether the main slot is sticky.
 */
export var MainStickyContext = /*#__PURE__*/createContext(false);